import React from 'react';
import styled from 'styled-components';

const CollapsibleContainer = styled.div`
  margin: 20px 0;
  background-color: ${({ theme }) => (theme === 'dark' ? '#231a2c' : '#231a2c')};
  border-radius: 15px;
  box-shadow: ${({ theme }) => theme === 'dark' ? '0 8px 20px rgba(0, 0, 0, 0.4)' : '0 4px 10px rgba(0, 0, 0, 0.1)'};
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    margin: 15px 0;
    padding: 10px;
  }
`;

const CollapsibleHeader = styled.div`
  padding: 16px;
  color: ${({ theme }) => (theme === 'dark' ? '#ecf0f1' : '#2c3e50')};
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => (theme === 'dark' ? '#231a2c' : '#231a2c')};
  border-radius: 12px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => (theme === 'dark' ? '#34495e' : '#e4e9f2')};
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 12px;
  }
`;

const CollapsibleContent = styled.div`
  padding: 16px;
  color: ${({ theme }) => (theme === 'dark' ? '#ecf0f1' : '#2c3e50')};
  font-size: 1rem;
  background-color: ${({ theme }) => (theme === 'dark' ? '#34495e' : '#fafafa')};
  border-radius: 0 0 12px 12px;
  box-shadow: ${({ theme }) => (theme === 'dark' ? '0 4px 10px rgba(0, 0, 0, 0.3)' : '0 4px 10px rgba(0, 0, 0, 0.1)')};

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 12px;
  }
`;

const CollapsibleSection = ({ title, isOpen, toggleOpen, children, theme }) => (
  <CollapsibleContainer theme={theme}>
    <CollapsibleHeader theme={theme} onClick={toggleOpen}>
      <span>{isOpen ? title : title}</span>
      <span>{isOpen ? '－' : '＋'}</span>
    </CollapsibleHeader>
    {isOpen && <CollapsibleContent theme={theme}>{children}</CollapsibleContent>}
  </CollapsibleContainer>
);

export default CollapsibleSection;
